import WidgetHero from './WidgetHero';
export type { WidgetHeroProps } from './WidgetHero.types';

export default WidgetHero;
